module.exports = __webpack_public_path__ + "img/SIRAT_COULEUR.110d01d0.png";